import React from 'react';
import { Link } from 'react-router-dom';
import 'font-awesome/css/font-awesome.min.css';
import './footer.css';

function FooterComp() {
  return (
    <footer className="footer">

      {/* PNG overlay */}
      <img 
        src="/kandy perahara.png" 
        alt="Kandy Perahara"
        className="footer-background"
      />

      {/* Footer content */}
      <div className="footer-content">

        <div className="footer-container">
          <div className="footer-section quick-links">
            <h2>Quick Links</h2>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/aboutus">About Us</Link></li>
              <li><Link to="/dhammapada">Dhammapada</Link></li>
              <li><Link to="/event">Event</Link></li>
              {/* <li><Link to="/gallery">Gallery</Link></li> */}
              <li><Link to="/contactus">Contact Us</Link></li>
 
            </ul>
          </div>

          <div className="footer-section contact">
            <h2>Contact Us</h2>
            <p>Email: <a href="mailto:sridhammasamadhibuddhistcenter@gmail.com">
              sridhammasamadhibuddhistcenter@gmail.com</a>
            </p>
            <p><a href="tel:+94771056968">Tel: +94 77 105 6968</a></p>
            <p>Address: Sri Dhamma Samadhi Buddhist Center, Bokundara, Piliyandala, Sri Lanka</p>
          </div>

          <div className="footer-section social-media">
            <h2>Follow Us</h2>
            <div className="social-icons">
              <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fa fa-facebook"></i>
              </a>

              <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fa fa-youtube"></i>
              </a>

              <a href="#" target="_blank" rel="noopener noreferrer" className="social-icon">
                <i className="fa fa-instagram"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>
            © 2026 Sri Dhamma Samadhi Buddhist Centre. All rights reserved. |
            Designed & Developed by
            <a
              className="glaxmore-link"
              href="https://www.glaxmore.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              &ensp;GLAXMORE
            </a>
          </p>
        </div>

      </div>
    </footer>
  );
}

export default FooterComp;